import { render } from "./qualite-certifications.vue?vue&type=template&id=1aba2b3a&scoped=true"
import script from "./qualite-certifications.vue?vue&type=script&lang=js"
export * from "./qualite-certifications.vue?vue&type=script&lang=js"

import "./qualite-certifications.vue?vue&type=style&index=0&id=1aba2b3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aba2b3a"]])

export default __exports__